
module.exports = (function ($, window, document, undefined) {
    "use strict";
    var self;
    var count = 0;
    // Create the defaults once
    var pluginName = "gpmCurrencyRatesBoard",
        defaults = {
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        self = this;
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
        this.lct = LibraryCommonHelpers;
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {

            String.prototype.format = function () {
                var args = arguments;
                return this.replace(/\{\{|\}\}|\{(\d+)\}/g,
                    function (m, n) {
                        if (m == "{{") {
                            return "{";
                        }
                        if (m == "}}") {
                            return "}";
                        }
                        return args[n];
                    });
            };

            //Variables
            self.$el = $(this.element);
            self.Product = $('#Product');
            self.Currency = $('#Currency');
            self.FromCurrency = $('#FromCurrency');
            self.ToCurrency = $('#ToCurrency');
            self.PopularCurrencies = $('#PopularCurrencies');
            self.OtherCurrencies = $('#OtherCurrencies');
            self.currencyRate = $("#ExchangeRate");
            //defaults
            self.Currency.select2({
                escapeMarkup: function (m) { return m; }
            });

            var currencies = self.Product.data('currencies');
            var rate = { "Rate": 1, "Target": self.Product.data('default-from') };
            var currency = JSON.parse(self.getCurrencyData(rate, currencies[rate.Target]));
            self.setCurrenciesAttributes('#FromCurrency-group', currency, 0);

            // add default active to first button 
            self.Product.children("button:first").addClass('active');
            //Bindings            
            self.Product.children("button").click(event, function () {
                var btnid = $(this).attr('id');
                // make clicked button active
                self.Product.children("button").removeClass('active');
                $(this).addClass('active');
                self.ProductChanged(btnid);
            });
            // set width of currency inputs with default val
            self.setInputWidth();

            self.Currency.change($.proxy(self.CurrencyChanged, self));
            self.FromCurrency.keyup($.proxy(self.CurrencyChanged, self, 0));
            self.ToCurrency.keyup($.proxy(self.CurrencyChanged, self, 1));

            self.FromCurrency.on('blur', self.FromCurrency, function () {
                self.FromCurrency.val(self.addCommas(self.FromCurrency.val()));
                self.setInputWidth();
            });
            self.FromCurrency.on('focus', self.FromCurrency, function () {
                self.FromCurrency.val(self.removeCommas(self.FromCurrency.val()));
                self.setInputWidth();
            });
            self.ToCurrency.on('blur', self.ToCurrency, function () {
                self.ToCurrency.val(self.addCommas(self.ToCurrency.val()));
                self.setInputWidth();
            });
            self.ToCurrency.on('focus', self.ToCurrency, function () {
                self.ToCurrency.val(self.removeCommas(self.ToCurrency.val()));
                self.setInputWidth();
            });
            self.ProductChanged(0);
        },
        ProductChanged: function (btnid) {
            if (btnid) {
                var rates = self.Product.children('button#' + btnid).data('rates');
            }
            else {
                var rates = self.Product.children('button:first').data('rates');
            }

            var currencies = self.Product.data('currencies');
            self.Currency.empty();
            var data = $.map(rates, function (rate) {
                var currency = currencies[rate.Target];
              var option = new Option('<i class="flag-icon flag-icon-{0}"></i> {1}'.format(rate.Target.substring(0, 2).toLowerCase(), currency.Title), rate.Target, false, false);
                option.setAttribute("data-currency", self.getCurrencyData(rate, currency));
                self.Currency.append(option);
                return true;
            });
            self.Currency.val(self.Product.data('default-to')).trigger('change.select2');
            self.getListOfRates(rates, currencies);
            if ($("#Currency").length) {
                self.getRateCalculated(0, btnid);
            }
            self.getUpdatedDate(btnid);
        },
        CurrencyChanged: function (curr_to_check) {
            self.getRateCalculated(curr_to_check, 0);
            self.setInputWidth();
        },
        getRateCalculated: function (curr_to_check, btnid) {
            var currency = self.Currency.children('option:selected').data('currency');
            var resultTo, resultFrom;
            if (!curr_to_check) {
                var fromVal = self.FromCurrency.val();
                resultFrom = (self.removeCommas(fromVal) * currency.Rate).toFixed(2);
                // add commas
                self.ToCurrency.val(self.addCommas(resultFrom));
            } else {
                var toVal = self.ToCurrency.val();
                resultTo = (self.removeCommas(toVal) / currency.Rate).toFixed(2);
                // add commas
                self.FromCurrency.val(self.addCommas(resultTo));
            }
            self.setCurrenciesAttributes('#ToCurrency-group', currency, btnid);

        },
        setCurrenciesAttributes: function (target, currency, btnid) {
            $(target + ' i').attr('class', 'flag-icon flag-icon-' + currency.Code.substring(0, 2).toLowerCase());
            $(target + ' label').html(currency.Title);
            $(target + ' .code').html(currency.Code);
            $(target + ' .symbol').html(currency.Symbol);

            if (count == 0) {
                self.currencyRate.find('span#fromCurrCode').html(currency.Code);
                self.currencyRate.find('span#fromSymbol').html(currency.Symbol);
            }
            else {
                self.currencyRate.find('span#toCurr').html(currency.Rate);
                self.currencyRate.find('span#toCurrCode').html(currency.Code);
                self.currencyRate.find('span#toSymbol').html(currency.Symbol);
            }
            count = count + 1;
        },
        getUpdatedDate: function (btnid) {
            var currentDate = "";
            if (btnid) {
                currentDate = self.Product.children('button#' + btnid).data('date');
            } else {
                currentDate = self.Product.children('button:first-child').data('date');
            }
            $('.DateUpdated').html(new Date(currentDate));
        },
        setInputWidth: function () {
            var defWidth = 54;
            var font = "700 30px UniversLTW02-47LightCn";
            var extraW = 0;

            var inputextTo = self.ToCurrency.val();
            var inputextFrom = self.FromCurrency.val();

            if ($(window).width() < 1199.98) {
                font = "700 28px UniversLTW02-47LightCn";
            }
            if ($(window).width() < 992) {
                font = "700 22px UniversLTW02-47LightCn";
            } else {
                extraW = 3;
            }

            var wF = self.getTextWidth(inputextFrom, font, 0);
            var wT = self.getTextWidth(inputextTo, font, 1);

            wF = wF ? wF : defWidth;
            wT = wT ? wT : defWidth;

            self.FromCurrency.width(wF + extraW);
            self.ToCurrency.width(wT + extraW);
        },
        getTextWidth: function (text, font, flag) {
            // re-use canvas object for better performance
            var canvas = self.getTextWidth.canvas || (self.getTextWidth.canvas = document.createElement("canvas"));
            var context = canvas.getContext("2d");
            context.font = font;
            var metrics = context.measureText(text);
            return metrics.width;
        },
        addCommas: function (nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        removeCommas: function (str) {
            var newVal = '';
            if (str.indexOf(',') > -1) {
                for (var x = 0; x < str.length; x++) {
                    var c = str.charAt(x).replace(',', '');
                    if (c != '' && c != 'undefined')
                        newVal += c;
                }
                newVal = parseFloat(newVal);
            }
            newVal = newVal ? newVal : str;
            return newVal;
        },
        getCurrencyData: function (rate, currency) {
            return '{ "Rate": "{0}", "Code": "{1}", "Title": "{2}", "Symbol": "{3}" }'.format(rate.Rate, rate.Target, currency.Title, currency.Symbol);
        },
        getListOfRates: function (rates, currencies) {
            self.PopularCurrencies.empty();
            self.OtherCurrencies.empty();
            var popularCurrencies = self.Product.data('popular-currencies');
            for (var i = 0; i < rates.length; i++) {
              var row = '<tr><td><i class="flag-icon flag-icon-{0}"></i> <span class="curr-name">{1}</span></td><td>{2} {3} {4}</td></tr>'.format(rates[i].Target.substring(0, 2).toLowerCase(), currencies[rates[i].Target].Title, currencies[rates[i].Target].Symbol, rates[i].Rate, rates[i].Target);

                if (self.Product.data('popular-currencies').indexOf(rates[i].Target) >= 0) {
                    self.PopularCurrencies.append(row);
                } else {
                    self.OtherCurrencies.append(row);
                }
            }
        },
        formatCurrency: function (rate) {
            var $option = $(
                '<i class="flag-icon flag-icon-ua"></i> ' + rate.text
            );
            return $option;
        },

    });

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);
